import { render, staticRenderFns } from "./QnaItemsListItem.vue?vue&type=template&id=2f86bbee"
import script from "./QnaItemsListItem.vue?vue&type=script&lang=ts"
export * from "./QnaItemsListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports